import React, { useEffect, useRef } from 'react';
import './Dropdown.css';

interface DropdownProps {
  children: React.ReactNode;
  onClose: () => void;
  ignoreRefs?: React.RefObject<HTMLElement>[];
}

const Dropdown: React.FC<DropdownProps> = ({ children, onClose, ignoreRefs }) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;

      const clickedInsideDropdown = dropdownRef.current?.contains(target);
      const clickedInsideIgnored = ignoreRefs?.some((ref) => ref.current?.contains(target));

      if (!clickedInsideDropdown && !clickedInsideIgnored) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  return (
    <div className="dropdownMenu" ref={dropdownRef}>
      {children}
    </div>
  );
};

export default Dropdown;
